import { gql } from "@apollo/client";
export const SEND_CLAIM_BALANCE_ORDER_GROUP = gql`
    mutation SendClaimBalance($where: claimBalanceOrderGroupInput) {
        sendClaimBalance(where: $where) {
            total
        }
    }
`;

export const REFRESH_CLAIM_BALANCE_FAILED = gql`
    mutation RefreshClaimBalanceFailed($where: claimBalanceOrderGroupInput) {
        refreshClaimBalanceFailed(where: $where)
    }
`;

export const CONFIRM_BALANCE = gql`
    mutation ConfirmBalance($where: claimBalanceOrderGroupInput) {
        confirmBalance(where: $where) {
            success
        }
    }
`;

// Joint Order Group
export const JOINT_ORDER_GROUP = gql`
    mutation JointOrderGroup($where: JointOrderGroupRequest!) {
        jointOrderGroup(where: $where) {
            message
            data {
                id
                amount
                phone
            }
        }
    }
`;

// Joint All Order Group
export const JOINT_ALL_ORDER_GROUP = gql`
    mutation JointAllOrderGroup($where: JointOrderGroupRequest!) {
        jointAllOrderGroup(where: $where) {
            message
            data {
                id
                amount
                phone
            }
        }
    }
`;

// Cancel Joint All Order Group
export const CANCEL_JOINT_ORDER_GROUP = gql`
    mutation CancelJointOrderGroup($where: CancelJointOrderGroupRequest!) {
        cancelJointOrderGroup(where: $where) {
            message
            data {
                id
            }
        }
    }
`;

// Create order group from comments
export const SEND_ORDER_GROUP_BILL = gql`
  mutation SendOrderGroupBill($where: SendOrderGroupBillInput!) {
    sendOrderGroupBill(where: $where) {
      status
      code
      msg
    }
  }
`;

export const CREATE_ORDER_FROM_FB_COMMENTS = gql`
    mutation CreateOrderFromFbComments($where: String!, $data: String!) {
        createOrderFromFbComments(where: $where, data: $data)
    }
`;